/**
 * Middle School Complete Vocabulary - Part L-Z (L-Z部分词汇)
 * 补充词汇约400个，达到1500词目标
 */

import { VocabularyWord } from './vocabulary';

export const vocabularyLN: VocabularyWord[] = [
  // L 部分词汇
  {
    id: 'lab', word: 'lab', phoneticUS: '/læb/', phoneticUK: '/læb/',
    meaning: '实验室', example: 'Science lab.', exampleTranslation: '科学实验室。',
    category: 'school', difficulty: 'easy', grade: '8', level: 'middle', image: '🔬'
  },
  {
    id: 'labor', word: 'labor', phoneticUS: '/ˈleɪbər/', phoneticUK: '/ˈleɪbə/',
    meaning: '劳动', example: 'Hard labor.', exampleTranslation: '辛苦劳动。',
    category: 'actions', difficulty: 'medium', grade: '9', level: 'middle', image: '💪'
  },
  {
    id: 'language', word: 'language', phoneticUS: '/ˈlæŋɡwɪdʒ/', phoneticUK: '/ˈlæŋɡwɪdʒ/',
    meaning: '语言', example: 'Learn a language.', exampleTranslation: '学习语言。',
    category: 'school', difficulty: 'easy', grade: '7', level: 'middle', image: '🗣️'
  },
  {
    id: 'large', word: 'large', phoneticUS: '/lɑrdʒ/', phoneticUK: '/lɑdʒ/',
    meaning: '大的', example: 'A large room.', exampleTranslation: '大房间。',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '🏠'
  },
  {
    id: 'last', word: 'last', phoneticUS: '/læst/', phoneticUK: '/læst/',
    meaning: '最后的', example: 'The last one.', exampleTranslation: '最后一个。',
    category: 'time', difficulty: 'easy', grade: '7', level: 'middle', image: '🔚'
  },
  {
    id: 'late', word: 'late', phoneticUS: '/leɪt/', phoneticUK: '/leɪt/',
    meaning: '迟的', example: 'Do not be late.', exampleTranslation: '不要迟到。',
    category: 'time', difficulty: 'easy', grade: '7', level: 'middle', image: '⏰'
  },
  {
    id: 'laugh', word: 'laugh', phoneticUS: '/læf/', phoneticUK: '/læf/',
    meaning: '笑', example: 'Laugh happily.', exampleTranslation: '开心地笑。',
    category: 'emotions', difficulty: 'easy', grade: '7', level: 'middle', image: '😂'
  },
  {
    id: 'law', word: 'law', phoneticUS: '/lɑ/', phoneticUK: '/lɔ/',
    meaning: '法律', example: 'Obey the law.', exampleTranslation: '遵守法律。',
    category: 'society', difficulty: 'medium', grade: '9', level: 'middle', image: '⚖️'
  },
  {
    id: 'lay', word: 'lay', phoneticUS: '/leɪ/', phoneticUK: '/leɪ/',
    meaning: '放置', example: 'Lay the book.', exampleTranslation: '放下书。',
    category: 'actions', difficulty: 'easy', grade: '8', level: 'middle', image: '📚'
  },
  {
    id: 'lazy', word: 'lazy', phoneticUS: '/ˈleɪzi/', phoneticUK: '/ˈleɪzi/',
    meaning: '懒惰的', example: 'Do not be lazy.', exampleTranslation: '不要懒惰。',
    category: 'abstract', difficulty: 'easy', grade: '8', level: 'middle', image: '😴'
  },
  {
    id: 'lead', word: 'lead', phoneticUS: '/liːd/', phoneticUK: '/liːd/',
    meaning: '领导', example: 'Lead the team.', exampleTranslation: '领导团队。',
    category: 'actions', difficulty: 'medium', grade: '9', level: 'middle', image: '👤'
  },
  {
    id: 'leader', word: 'leader', phoneticUS: '/ˈliːdər/', phoneticUK: '/ˈliːdə/',
    meaning: '领导者', example: 'A good leader.', exampleTranslation: '好的领导者。',
    category: 'jobs', difficulty: 'medium', grade: '9', level: 'middle', image: '👑'
  },
  {
    id: 'leaf', word: 'leaf', phoneticUS: '/liːf/', phoneticUK: '/liːf/',
    meaning: '叶子', example: 'Green leaves.', exampleTranslation: '绿色的叶子。',
    category: 'nature', difficulty: 'easy', grade: '7', level: 'middle', image: '🍃'
  },
  {
    id: 'learn', word: 'learn', phoneticUS: '/lɜrn/', phoneticUK: '/lɜn/',
    meaning: '学习', example: 'Learn English.', exampleTranslation: '学习英语。',
    category: 'actions', difficulty: 'easy', grade: '7', level: 'middle', image: '📚'
  },
  {
    id: 'least', word: 'least', phoneticUS: '/liːst/', phoneticUK: '/liːst/',
    meaning: '最少的', example: 'The least amount.', exampleTranslation: '最少的量。',
    category: 'abstract', difficulty: 'easy', grade: '8', level: 'middle', image: '📊'
  },
  {
    id: 'leave', word: 'leave', phoneticUS: '/liːv/', phoneticUK: '/liːv/',
    meaning: '离开', example: 'Leave early.', exampleTranslation: '早点离开。',
    category: 'actions', difficulty: 'easy', grade: '7', level: 'middle', image: '🚶'
  },
  {
    id: 'left', word: 'left', phoneticUS: '/left/', phoneticUK: '/left/',
    meaning: '左边', example: 'Turn left.', exampleTranslation: '左转。',
    category: 'directions', difficulty: 'easy', grade: '7', level: 'middle', image: '⬅️'
  },
  {
    id: 'leg', word: 'leg', phoneticUS: '/leɡ/', phoneticUK: '/leɡ/',
    meaning: '腿', example: 'My legs.', exampleTranslation: '我的腿。',
    category: 'body', difficulty: 'easy', grade: '7', level: 'middle', image: '🦵'
  },
  {
    id: 'lend', word: 'lend', phoneticUS: '/lend/', phoneticUK: '/lend/',
    meaning: '借出', example: 'Lend me a pen.', exampleTranslation: '借我一支笔。',
    category: 'actions', difficulty: 'easy', grade: '8', level: 'middle', image: '🤝'
  },
  {
    id: 'less', word: 'less', phoneticUS: '/les/', phoneticUK: '/les/',
    meaning: '较少的', example: 'Less time.', exampleTranslation: '更少的时间。',
    category: 'abstract', difficulty: 'easy', grade: '8', level: 'middle', image: '📉'
  },
  {
    id: 'lesson', word: 'lesson', phoneticUS: '/ˈlesən/', phoneticUK: '/ˈlesən/',
    meaning: '课程', example: 'English lesson.', exampleTranslation: '英语课。',
    category: 'school', difficulty: 'easy', grade: '7', level: 'middle', image: '📚'
  },
  {
    id: 'let', word: 'let', phoneticUS: '/let/', phoneticUK: '/let/',
    meaning: '让', example: 'Let me help.', exampleTranslation: '让我帮忙。',
    category: 'actions', difficulty: 'easy', grade: '7', level: 'middle', image: '🤝'
  },
  {
    id: 'letter', word: 'letter', phoneticUS: '/ˈletər/', phoneticUK: '/ˈletə/',
    meaning: '信；字母', example: 'Write a letter.', exampleTranslation: '写信。',
    category: 'daily_life', difficulty: 'easy', grade: '7', level: 'middle', image: '💌'
  },
  {
    id: 'level', word: 'level', phoneticUS: '/ˈlevəl/', phoneticUK: '/ˈlevəl/',
    meaning: '水平；等级', example: 'High level.', exampleTranslation: '高水平。',
    category: 'abstract', difficulty: 'medium', grade: '8', level: 'middle', image: '📊'
  },
  {
    id: 'library', word: 'library', phoneticUS: '/ˈlaɪbreri/', phoneticUK: '/ˈlaɪbrəri/',
    meaning: '图书馆', example: 'Go to the library.', exampleTranslation: '去图书馆。',
    category: 'places', difficulty: 'easy', grade: '7', level: 'middle', image: '📚'
  },
  {
    id: 'lie', word: 'lie', phoneticUS: '/laɪ/', phoneticUK: '/laɪ/',
    meaning: '躺；谎言', example: 'Do not lie.', exampleTranslation: '不要撒谎。',
    category: 'actions', difficulty: 'easy', grade: '8', level: 'middle', image: '🛏️'
  },
  {
    id: 'life', word: 'life', phoneticUS: '/laɪf/', phoneticUK: '/laɪf/',
    meaning: '生活；生命', example: 'Happy life.', exampleTranslation: '快乐的生活。',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '🌟'
  },
  {
    id: 'lift', word: 'lift', phoneticUS: '/lɪft/', phoneticUK: '/lɪft/',
    meaning: '举起；电梯', example: 'Lift the box.', exampleTranslation: '举起箱子。',
    category: 'actions', difficulty: 'easy', grade: '8', level: 'middle', image: '🏋️'
  },
  {
    id: 'light', word: 'light', phoneticUS: '/laɪt/', phoneticUK: '/laɪt/',
    meaning: '光；轻的', example: 'Turn on the light.', exampleTranslation: '开灯。',
    category: 'daily_life', difficulty: 'easy', grade: '7', level: 'middle', image: '💡'
  },
  {
    id: 'like', word: 'like', phoneticUS: '/laɪk/', phoneticUK: '/laɪk/',
    meaning: '喜欢', example: 'I like it.', exampleTranslation: '我喜欢。',
    category: 'emotions', difficulty: 'easy', grade: '7', level: 'middle', image: '👍'
  },
  {
    id: 'line', word: 'line', phoneticUS: '/laɪn/', phoneticUK: '/laɪn/',
    meaning: '线；排队', example: 'Draw a line.', exampleTranslation: '画线。',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '📏'
  },
  {
    id: 'list', word: 'list', phoneticUS: '/lɪst/', phoneticUK: '/lɪst/',
    meaning: '列表', example: 'Make a list.', exampleTranslation: '做列表。',
    category: 'abstract', difficulty: 'easy', grade: '8', level: 'middle', image: '📋'
  },
  {
    id: 'listen', word: 'listen', phoneticUS: '/ˈlɪsən/', phoneticUK: '/ˈlɪsən/',
    meaning: '听', example: 'Listen carefully.', exampleTranslation: '认真听。',
    category: 'actions', difficulty: 'easy', grade: '7', level: 'middle', image: '👂'
  },
  {
    id: 'little', word: 'little', phoneticUS: '/ˈlɪtl/', phoneticUK: '/ˈlɪtl/',
    meaning: '小的', example: 'A little cat.', exampleTranslation: '小猫。',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '🐱'
  },
  {
    id: 'live', word: 'live', phoneticUS: '/lɪv/', phoneticUK: '/lɪv/',
    meaning: '居住；生活', example: 'I live here.', exampleTranslation: '我住在这里。',
    category: 'actions', difficulty: 'easy', grade: '7', level: 'middle', image: '🏠'
  },
  {
    id: 'lock', word: 'lock', phoneticUS: '/lɑk/', phoneticUK: '/lɒk/',
    meaning: '锁', example: 'Lock the door.', exampleTranslation: '锁门。',
    category: 'actions', difficulty: 'easy', grade: '8', level: 'middle', image: '🔒'
  },
  {
    id: 'lonely', word: 'lonely', phoneticUS: '/ˈloʊnli/', phoneticUK: '/ˈləʊnli/',
    meaning: '孤独的', example: 'I feel lonely.', exampleTranslation: '我感到孤独。',
    category: 'emotions', difficulty: 'medium', grade: '9', level: 'middle', image: '😔'
  },
  {
    id: 'long', word: 'long', phoneticUS: '/lɑŋ/', phoneticUK: '/lɒŋ/',
    meaning: '长的', example: 'Long hair.', exampleTranslation: '长发。',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '💇'
  },
  {
    id: 'look', word: 'look', phoneticUS: '/lʊk/', phoneticUK: '/lʊk/',
    meaning: '看', example: 'Look at me.', exampleTranslation: '看着我。',
    category: 'actions', difficulty: 'easy', grade: '7', level: 'middle', image: '👀'
  },
  {
    id: 'lose', word: 'lose', phoneticUS: '/luːz/', phoneticUK: '/luːz/',
    meaning: '失去', example: 'Do not lose.', exampleTranslation: '不要失去。',
    category: 'actions', difficulty: 'easy', grade: '8', level: 'middle', image: '❌'
  },
  {
    id: 'lot', word: 'lot', phoneticUS: '/lɑt/', phoneticUK: '/lɒt/',
    meaning: '很多', example: 'A lot of books.', exampleTranslation: '很多书。',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '📚'
  },
  {
    id: 'love', word: 'love', phoneticUS: '/lʌv/', phoneticUK: '/lʌv/',
    meaning: '爱', example: 'I love you.', exampleTranslation: '我爱你。',
    category: 'emotions', difficulty: 'easy', grade: '7', level: 'middle', image: '❤️'
  },
  {
    id: 'low', word: 'low', phoneticUS: '/loʊ/', phoneticUK: '/ləʊ/',
    meaning: '低的', example: 'Low price.', exampleTranslation: '低价格。',
    category: 'abstract', difficulty: 'easy', grade: '8', level: 'middle', image: '📉'
  },
  {
    id: 'luck', word: 'luck', phoneticUS: '/lʌk/', phoneticUK: '/lʌk/',
    meaning: '运气', example: 'Good luck!', exampleTranslation: '祝好运！',
    category: 'abstract', difficulty: 'medium', grade: '9', level: 'middle', image: '🍀'
  },
  {
    id: 'lucky', word: 'lucky', phoneticUS: '/ˈlʌki/', phoneticUK: '/ˈlʌki/',
    meaning: '幸运的', example: 'I am lucky.', exampleTranslation: '我很幸运。',
    category: 'abstract', difficulty: 'medium', grade: '9', level: 'middle', image: '🍀'
  },
  {
    id: 'lunch', word: 'lunch', phoneticUS: '/lʌntʃ/', phoneticUK: '/lʌntʃ/',
    meaning: '午餐', example: 'Have lunch.', exampleTranslation: '吃午餐。',
    category: 'food', difficulty: 'easy', grade: '7', level: 'middle', image: '🍽️'
  },

  // M 部分词汇
  {
    id: 'machine', word: 'machine', phoneticUS: '/məˈʃiːn/', phoneticUK: '/məˈʃiːn/',
    meaning: '机器', example: 'Use a machine.', exampleTranslation: '使用机器。',
    category: 'technology', difficulty: 'medium', grade: '9', level: 'middle', image: '🤖'
  },
  {
    id: 'madam', word: 'madam', phoneticUS: '/ˈmædəm/', phoneticUK: '/ˈmædəm/',
    meaning: '女士', example: 'Yes, madam.', exampleTranslation: '是的，女士。',
    category: 'abstract', difficulty: 'medium', grade: '9', level: 'middle', image: '👩'
  },
  {
    id: 'magic', word: 'magic', phoneticUS: '/ˈmædʒɪk/', phoneticUK: '/ˈmædʒɪk/',
    meaning: '魔法', example: 'Magic show.', exampleTranslation: '魔术表演。',
    category: 'abstract', difficulty: 'medium', grade: '9', level: 'middle', image: '✨'
  },
  {
    id: 'main', word: 'main', phoneticUS: '/meɪn/', phoneticUK: '/meɪn/',
    meaning: '主要的', example: 'Main idea.', exampleTranslation: '主要想法。',
    category: 'abstract', difficulty: 'medium', grade: '8', level: 'middle', image: '⭐'
  },
  {
    id: 'make', word: 'make', phoneticUS: '/meɪk/', phoneticUK: '/meɪk/',
    meaning: '制作', example: 'Make a cake.', exampleTranslation: '做蛋糕。',
    category: 'actions', difficulty: 'easy', grade: '7', level: 'middle', image: '🎂'
  },
  {
    id: 'man', word: 'man', phoneticUS: '/mæn/', phoneticUK: '/mæn/',
    meaning: '男人', example: 'A kind man.', exampleTranslation: '善良的男人。',
    category: 'family', difficulty: 'easy', grade: '7', level: 'middle', image: '👨'
  },
  {
    id: 'manage', word: 'manage', phoneticUS: '/ˈmænɪdʒ/', phoneticUK: '/ˈmænɪdʒ/',
    meaning: '管理', example: 'Manage time.', exampleTranslation: '管理时间。',
    category: 'actions', difficulty: 'hard', grade: '9', level: 'middle', image: '📋'
  },
  {
    id: 'many', word: 'many', phoneticUS: '/ˈmeni/', phoneticUK: '/ˈmeni/',
    meaning: '许多', example: 'Many books.', exampleTranslation: '许多书。',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '📚'
  },
  {
    id: 'map', word: 'map', phoneticUS: '/mæp/', phoneticUK: '/mæp/',
    meaning: '地图', example: 'Read a map.', exampleTranslation: '看地图。',
    category: 'travel', difficulty: 'easy', grade: '7', level: 'middle', image: '🗺️'
  },
  {
    id: 'mark', word: 'mark', phoneticUS: '/mɑrk/', phoneticUK: '/mɑk/',
    meaning: '标记；分数', example: 'Good mark.', exampleTranslation: '好分数。',
    category: 'school', difficulty: 'easy', grade: '8', level: 'middle', image: '📝'
  },
  {
    id: 'market', word: 'market', phoneticUS: '/ˈmɑrkɪt/', phoneticUK: '/ˈmɑkɪt/',
    meaning: '市场', example: 'Go to the market.', exampleTranslation: '去市场。',
    category: 'places', difficulty: 'easy', grade: '8', level: 'middle', image: '🏪'
  },
  {
    id: 'marry', word: 'marry', phoneticUS: '/ˈmæri/', phoneticUK: '/ˈmæri/',
    meaning: '结婚', example: 'Get married.', exampleTranslation: '结婚。',
    category: 'actions', difficulty: 'medium', grade: '9', level: 'middle', image: '💒'
  },
  {
    id: 'match', word: 'match', phoneticUS: '/mætʃ/', phoneticUK: '/mætʃ/',
    meaning: '比赛；匹配', example: 'Watch a match.', exampleTranslation: '看比赛。',
    category: 'sports', difficulty: 'easy', grade: '8', level: 'middle', image: '⚽'
  },
  {
    id: 'material', word: 'material', phoneticUS: '/məˈtɪriəl/', phoneticUK: '/məˈtɪriəl/',
    meaning: '材料', example: 'Study material.', exampleTranslation: '学习材料。',
    category: 'abstract', difficulty: 'medium', grade: '9', level: 'middle', image: '📚'
  },
  {
    id: 'math', word: 'math', phoneticUS: '/mæθ/', phoneticUK: '/mæθ/',
    meaning: '数学', example: 'I like math.', exampleTranslation: '我喜欢数学。',
    category: 'school', difficulty: 'easy', grade: '7', level: 'middle', image: '📐'
  },
  {
    id: 'matter', word: 'matter', phoneticUS: '/ˈmætər/', phoneticUK: '/ˈmætə/',
    meaning: '事情；重要', example: 'It matters.', exampleTranslation: '这很重要。',
    category: 'abstract', difficulty: 'medium', grade: '9', level: 'middle', image: '❗'
  },
  {
    id: 'May', word: 'May', phoneticUS: '/meɪ/', phoneticUK: '/meɪ/',
    meaning: '五月', example: 'May is warm.', exampleTranslation: '五月很暖和。',
    category: 'months', difficulty: 'easy', grade: '7', level: 'middle', image: '🌸'
  },
  {
    id: 'maybe', word: 'maybe', phoneticUS: '/ˈmeɪbi/', phoneticUK: '/ˈmeɪbi/',
    meaning: '可能', example: 'Maybe tomorrow.', exampleTranslation: '可能明天。',
    category: 'abstract', difficulty: 'easy', grade: '8', level: 'middle', image: '🤔'
  },
  {
    id: 'me', word: 'me', phoneticUS: '/mi/', phoneticUK: '/mi/',
    meaning: '我（宾格）', example: 'Help me.', exampleTranslation: '帮帮我。',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '👤'
  },
  {
    id: 'meal', word: 'meal', phoneticUS: '/miːl/', phoneticUK: '/miːl/',
    meaning: '一顿饭', example: 'Have a meal.', exampleTranslation: '吃饭。',
    category: 'food', difficulty: 'medium', grade: '8', level: 'middle', image: '🍽️'
  },
  {
    id: 'mean', word: 'mean', phoneticUS: '/miːn/', phoneticUK: '/miːn/',
    meaning: '意思是', example: 'What does it mean?', exampleTranslation: '这是什么意思？',
    category: 'actions', difficulty: 'medium', grade: '8', level: 'middle', image: '❓'
  },
  {
    id: 'meaning', word: 'meaning', phoneticUS: '/ˈmiːnɪŋ/', phoneticUK: '/ˈmiːnɪŋ/',
    meaning: '意义', example: 'The meaning is clear.', exampleTranslation: '意义很清楚。',
    category: 'abstract', difficulty: 'medium', grade: '9', level: 'middle', image: '💡'
  },
  {
    id: 'meat', word: 'meat', phoneticUS: '/miːt/', phoneticUK: '/miːt/',
    meaning: '肉', example: 'Eat meat.', exampleTranslation: '吃肉。',
    category: 'food', difficulty: 'easy', grade: '7', level: 'middle', image: '🥩'
  },
  {
    id: 'medicine', word: 'medicine', phoneticUS: '/ˈmedɪsən/', phoneticUK: '/ˈmedɪsən/',
    meaning: '药', example: 'Take medicine.', exampleTranslation: '吃药。',
    category: 'body', difficulty: 'medium', grade: '9', level: 'middle', image: '💊'
  },
  {
    id: 'meet', word: 'meet', phoneticUS: '/miːt/', phoneticUK: '/miːt/',
    meaning: '遇见', example: 'Meet friends.', exampleTranslation: '见朋友。',
    category: 'actions', difficulty: 'easy', grade: '7', level: 'middle', image: '👋'
  },
  {
    id: 'meeting', word: 'meeting', phoneticUS: '/ˈmiːtɪŋ/', phoneticUK: '/ˈmiːtɪŋ/',
    meaning: '会议', example: 'Have a meeting.', exampleTranslation: '开会。',
    category: 'abstract', difficulty: 'medium', grade: '8', level: 'middle', image: '👥'
  },
  {
    id: 'member', word: 'member', phoneticUS: '/ˈmembər/', phoneticUK: '/ˈmembə/',
    meaning: '成员', example: 'Team member.', exampleTranslation: '团队成员。',
    category: 'abstract', difficulty: 'medium', grade: '9', level: 'middle', image: '👤'
  },
  {
    id: 'memory', word: 'memory', phoneticUS: '/ˈmeməri/', phoneticUK: '/ˈmeməri/',
    meaning: '记忆', example: 'Good memory.', exampleTranslation: '好的记忆。',
    category: 'abstract', difficulty: 'medium', grade: '9', level: 'middle', image: '🧠'
  },
  {
    id: 'mend', word: 'mend', phoneticUS: '/mend/', phoneticUK: '/mend/',
    meaning: '修理', example: 'Mend the clothes.', exampleTranslation: '修补衣服。',
    category: 'actions', difficulty: 'medium', grade: '9', level: 'middle', image: '🧵'
  },
  {
    id: 'mention', word: 'mention', phoneticUS: '/ˈmenʃn/', phoneticUK: '/ˈmenʃn/',
    meaning: '提到', example: 'Mention it.', exampleTranslation: '提到它。',
    category: 'actions', difficulty: 'hard', grade: '9', level: 'middle', image: '💬'
  },
  {
    id: 'menu', word: 'menu', phoneticUS: '/ˈmenjuː/', phoneticUK: '/ˈmenjuː/',
    meaning: '菜单', example: 'Look at the menu.', exampleTranslation: '看菜单。',
    category: 'food', difficulty: 'easy', grade: '8', level: 'middle', image: '📋'
  },
  {
    id: 'message', word: 'message', phoneticUS: '/ˈmesɪdʒ/', phoneticUK: '/ˈmesɪdʒ/',
    meaning: '消息', example: 'Send a message.', exampleTranslation: '发消息。',
    category: 'technology', difficulty: 'easy', grade: '8', level: 'middle', image: '💬'
  },
  {
    id: 'metal', word: 'metal', phoneticUS: '/ˈmetəl/', phoneticUK: '/ˈmetəl/',
    meaning: '金属', example: 'Metal is hard.', exampleTranslation: '金属很硬。',
    category: 'abstract', difficulty: 'medium', grade: '9', level: 'middle', image: '🔩'
  },
  {
    id: 'method', word: 'method', phoneticUS: '/ˈmetəd/', phoneticUK: '/ˈmetəd/',
    meaning: '方法', example: 'Use this method.', exampleTranslation: '用这个方法。',
    category: 'abstract', difficulty: 'medium', grade: '9', level: 'middle', image: '💡'
  },
  {
    id: 'middle', word: 'middle', phoneticUS: '/ˈmɪdl/', phoneticUK: '/ˈmɪdl/',
    meaning: '中间的', example: 'Middle school.', exampleTranslation: '中学。',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '🏫'
  },
  {
    id: 'milk', word: 'milk', phoneticUS: '/mɪlk/', phoneticUK: '/mɪlk/',
    meaning: '牛奶', example: 'Drink milk.', exampleTranslation: '喝牛奶。',
    category: 'food', difficulty: 'easy', grade: '7', level: 'middle', image: '🥛'
  },
  {
    id: 'mind', word: 'mind', phoneticUS: '/maɪnd/', phoneticUK: '/maɪnd/',
    meaning: '思想；介意', example: 'Open your mind.', exampleTranslation: '敞开心扉。',
    category: 'abstract', difficulty: 'medium', grade: '9', level: 'middle', image: '🧠'
  },
  {
    id: 'minute', word: 'minute', phoneticUS: '/ˈmɪnɪt/', phoneticUK: '/ˈmɪnɪt/',
    meaning: '分钟', example: 'Five minutes.', exampleTranslation: '五分钟。',
    category: 'time', difficulty: 'easy', grade: '7', level: 'middle', image: '⏰'
  },
  {
    id: 'mirror', word: 'mirror', phoneticUS: '/ˈmɪrər/', phoneticUK: '/ˈmɪrə/',
    meaning: '镜子', example: 'Look in the mirror.', exampleTranslation: '照镜子。',
    category: 'daily_life', difficulty: 'medium', grade: '8', level: 'middle', image: '🪞'
  },
  {
    id: 'miss', word: 'miss', phoneticUS: '/mɪs/', phoneticUK: '/mɪs/',
    meaning: '错过；想念', example: 'Miss you.', exampleTranslation: '想念你。',
    category: 'emotions', difficulty: 'easy', grade: '8', level: 'middle', image: '💕'
  },
  {
    id: 'mix', word: 'mix', phoneticUS: '/mɪks/', phoneticUK: '/mɪks/',
    meaning: '混合', example: 'Mix colors.', exampleTranslation: '混合颜色。',
    category: 'actions', difficulty: 'easy', grade: '8', level: 'middle', image: '🎨'
  },
  {
    id: 'model', word: 'model', phoneticUS: '/ˈmɑdl/', phoneticUK: '/ˈmɒdl/',
    meaning: '模型', example: 'Build a model.', exampleTranslation: '做模型。',
    category: 'abstract', difficulty: 'medium', grade: '9', level: 'middle', image: '🏗️'
  },
  {
    id: 'money', word: 'money', phoneticUS: '/ˈmʌni/', phoneticUK: '/ˈmʌni/',
    meaning: '钱', example: 'Save money.', exampleTranslation: '省钱。',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '💰'
  },
  {
    id: 'monkey', word: 'monkey', phoneticUS: '/ˈmʌŋki/', phoneticUK: '/ˈmʌŋki/',
    meaning: '猴子', example: 'A cute monkey.', exampleTranslation: '可爱的猴子。',
    category: 'animals', difficulty: 'easy', grade: '7', level: 'middle', image: '🐒'
  },
  {
    id: 'month', word: 'month', phoneticUS: '/mʌnθ/', phoneticUK: '/mʌnθ/',
    meaning: '月', example: 'Next month.', exampleTranslation: '下个月。',
    category: 'time', difficulty: 'easy', grade: '7', level: 'middle', image: '📅'
  },
  {
    id: 'moon', word: 'moon', phoneticUS: '/muːn/', phoneticUK: '/muːn/',
    meaning: '月亮', example: 'Bright moon.', exampleTranslation: '明亮的月亮。',
    category: 'nature', difficulty: 'easy', grade: '7', level: 'middle', image: '🌙'
  },
  {
    id: 'more', word: 'more', phoneticUS: '/mɔr/', phoneticUK: '/mɔ/',
    meaning: '更多的', example: 'More time.', exampleTranslation: '更多时间。',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '➕'
  },
  {
    id: 'morning', word: 'morning', phoneticUS: '/ˈmɔrnɪŋ/', phoneticUK: '/ˈmɔnɪŋ/',
    meaning: '早晨', example: 'Good morning!', exampleTranslation: '早上好！',
    category: 'time', difficulty: 'easy', grade: '7', level: 'middle', image: '🌅'
  },
  {
    id: 'most', word: 'most', phoneticUS: '/moʊst/', phoneticUK: '/məʊst/',
    meaning: '最多的', example: 'Most people.', exampleTranslation: '大多数人。',
    category: 'abstract', difficulty: 'easy', grade: '8', level: 'middle', image: '🏆'
  },
  {
    id: 'mother', word: 'mother', phoneticUS: '/ˈmʌðər/', phoneticUK: '/ˈmʌðə/',
    meaning: '母亲', example: 'My mother.', exampleTranslation: '我的母亲。',
    category: 'family', difficulty: 'easy', grade: '7', level: 'middle', image: '👩'
  },
  {
    id: 'mountain', word: 'mountain', phoneticUS: '/ˈmaʊntən/', phoneticUK: '/ˈmaʊntən/',
    meaning: '山', example: 'High mountain.', exampleTranslation: '高山。',
    category: 'nature', difficulty: 'easy', grade: '8', level: 'middle', image: '🏔️'
  },
  {
    id: 'mouth', word: 'mouth', phoneticUS: '/maʊθ/', phoneticUK: '/maʊθ/',
    meaning: '嘴巴', example: 'Open your mouth.', exampleTranslation: '张开嘴。',
    category: 'body', difficulty: 'easy', grade: '7', level: 'middle', image: '👄'
  },
  {
    id: 'move', word: 'move', phoneticUS: '/muːv/', phoneticUK: '/muːv/',
    meaning: '移动', example: 'Move forward.', exampleTranslation: '向前移动。',
    category: 'actions', difficulty: 'easy', grade: '7', level: 'middle', image: '🚶'
  },
  {
    id: 'movie', word: 'movie', phoneticUS: '/ˈmuːvi/', phoneticUK: '/ˈmuːvi/',
    meaning: '电影', example: 'Watch a movie.', exampleTranslation: '看电影。',
    category: 'hobbies', difficulty: 'easy', grade: '7', level: 'middle', image: '🎬'
  },
  {
    id: 'much', word: 'much', phoneticUS: '/mʌtʃ/', phoneticUK: '/mʌtʃ/',
    meaning: '很多', example: 'Much better.', exampleTranslation: '好很多。',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '📈'
  },
  {
    id: 'museum', word: 'museum', phoneticUS: '/mjuˈziːəm/', phoneticUK: '/mjuˈziːəm/',
    meaning: '博物馆', example: 'Visit a museum.', exampleTranslation: '参观博物馆。',
    category: 'places', difficulty: 'medium', grade: '9', level: 'middle', image: '🏛️'
  },
  {
    id: 'music', word: 'music', phoneticUS: '/ˈmjuːzɪk/', phoneticUK: '/ˈmjuːzɪk/',
    meaning: '音乐', example: 'Listen to music.', exampleTranslation: '听音乐。',
    category: 'hobbies', difficulty: 'easy', grade: '7', level: 'middle', image: '🎵'
  },
  {
    id: 'must', word: 'must', phoneticUS: '/mʌst/', phoneticUK: '/mʌst/',
    meaning: '必须', example: 'You must study.', exampleTranslation: '你必须学习。',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '⚠️'
  },
  {
    id: 'my', word: 'my', phoneticUS: '/maɪ/', phoneticUK: '/maɪ/',
    meaning: '我的', example: 'My book.', exampleTranslation: '我的书。',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '📚'
  },
  {
    id: 'myself', word: 'myself', phoneticUS: '/maɪˈself/', phoneticUK: '/maɪˈself/',
    meaning: '我自己', example: 'I do it myself.', exampleTranslation: '我自己做。',
    category: 'abstract', difficulty: 'easy', grade: '8', level: 'middle', image: '👤'
  },

  // N 部分词汇
  {
    id: 'name', word: 'name', phoneticUS: '/neɪm/', phoneticUK: '/neɪm/',
    meaning: '名字', example: 'My name is...', exampleTranslation: '我的名字是...',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '📛'
  },
  {
    id: 'narrow', word: 'narrow', phoneticUS: '/ˈnæroʊ/', phoneticUK: '/ˈnærəʊ/',
    meaning: '狭窄的', example: 'A narrow road.', exampleTranslation: '狭窄的路。',
    category: 'abstract', difficulty: 'medium', grade: '9', level: 'middle', image: '🛣️'
  },
  {
    id: 'nation', word: 'nation', phoneticUS: '/ˈneɪʃn/', phoneticUK: '/ˈneɪʃn/',
    meaning: '国家', example: 'A great nation.', exampleTranslation: '伟大的国家。',
    category: 'society', difficulty: 'hard', grade: '9', level: 'middle', image: '🇺🇳'
  },
  {
    id: 'national', word: 'national', phoneticUS: '/ˈnæʃnəl/', phoneticUK: '/ˈnæʃnəl/',
    meaning: '国家的', example: 'National day.', exampleTranslation: '国庆节。',
    category: 'society', difficulty: 'medium', grade: '9', level: 'middle', image: '🇺🇳'
  },
  {
    id: 'natural', word: 'natural', phoneticUS: '/ˈnætʃərəl/', phoneticUK: '/ˈnætʃərəl/',
    meaning: '自然的', example: 'Natural beauty.', exampleTranslation: '自然之美。',
    category: 'nature', difficulty: 'medium', grade: '9', level: 'middle', image: '🌿'
  },
  {
    id: 'nature', word: 'nature', phoneticUS: '/ˈneɪtʃər/', phoneticUK: '/ˈneɪtʃə/',
    meaning: '自然', example: 'Love nature.', exampleTranslation: '热爱自然。',
    category: 'nature', difficulty: 'medium', grade: '8', level: 'middle', image: '🌳'
  },
  {
    id: 'near', word: 'near', phoneticUS: '/nɪr/', phoneticUK: '/nɪə/',
    meaning: '近的', example: 'Near my home.', exampleTranslation: '在我家附近。',
    category: 'directions', difficulty: 'easy', grade: '7', level: 'middle', image: '📍'
  },
  {
    id: 'nearly', word: 'nearly', phoneticUS: '/ˈnɪrli/', phoneticUK: '/ˈnɪli/',
    meaning: '几乎', example: 'Nearly done.', exampleTranslation: '几乎完成了。',
    category: 'abstract', difficulty: 'medium', grade: '9', level: 'middle', image: '✅'
  },
  {
    id: 'necessary', word: 'necessary', phoneticUS: '/ˈnesəseri/', phoneticUK: '/ˈnesəsəri/',
    meaning: '必要的', example: 'It is necessary.', exampleTranslation: '这是必要的。',
    category: 'abstract', difficulty: 'medium', grade: '9', level: 'middle', image: '✅'
  },
  {
    id: 'need', word: 'need', phoneticUS: '/niːd/', phoneticUK: '/niːd/',
    meaning: '需要', example: 'I need help.', exampleTranslation: '我需要帮助。',
    category: 'actions', difficulty: 'easy', grade: '7', level: 'middle', image: '🤝'
  },
  {
    id: 'neck', word: 'neck', phoneticUS: '/nek/', phoneticUK: '/nek/',
    meaning: '脖子', example: 'Protect your neck.', exampleTranslation: '保护脖子。',
    category: 'body', difficulty: 'medium', grade: '9', level: 'middle', image: '👤'
  },
  {
    id: 'neighbor', word: 'neighbor', phoneticUS: '/ˈneɪbər/', phoneticUK: '/ˈneɪbə/',
    meaning: '邻居', example: 'My neighbor.', exampleTranslation: '我的邻居。',
    category: 'abstract', difficulty: 'medium', grade: '8', level: 'middle', image: '🏠'
  },
  {
    id: 'neither', word: 'neither', phoneticUS: '/ˈniːðər/', phoneticUK: '/ˈnaɪðə/',
    meaning: '两者都不', example: 'Neither is good.', exampleTranslation: '都不好。',
    category: 'abstract', difficulty: 'medium', grade: '9', level: 'middle', image: '❌'
  },
  {
    id: 'nervous', word: 'nervous', phoneticUS: '/ˈnɜrvəs/', phoneticUK: '/ˈnɜvəs/',
    meaning: '紧张的', example: 'I feel nervous.', exampleTranslation: '我感到紧张。',
    category: 'emotions', difficulty: 'medium', grade: '8', level: 'middle', image: '😰'
  },
  {
    id: 'never', word: 'never', phoneticUS: '/ˈnevər/', phoneticUK: '/ˈnevə/',
    meaning: '从不', example: 'Never give up.', exampleTranslation: '永不放弃。',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '💪'
  },
  {
    id: 'new', word: 'new', phoneticUS: '/nuː/', phoneticUK: '/njuː/',
    meaning: '新的', example: 'New book.', exampleTranslation: '新书。',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '📚'
  },
  {
    id: 'news', word: 'news', phoneticUS: '/nuːz/', phoneticUK: '/njuːz/',
    meaning: '新闻', example: 'Good news.', exampleTranslation: '好消息。',
    category: 'abstract', difficulty: 'easy', grade: '8', level: 'middle', image: '📰'
  },
  {
    id: 'next', word: 'next', phoneticUS: '/nekst/', phoneticUK: '/nekst/',
    meaning: '下一个', example: 'Next week.', exampleTranslation: '下周。',
    category: 'time', difficulty: 'easy', grade: '7', level: 'middle', image: '➡️'
  },
  {
    id: 'nice', word: 'nice', phoneticUS: '/naɪs/', phoneticUK: '/naɪs/',
    meaning: '好的', example: 'Nice day.', exampleTranslation: '好的一天。',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '😊'
  },
  {
    id: 'night', word: 'night', phoneticUS: '/naɪt/', phoneticUK: '/naɪt/',
    meaning: '夜晚', example: 'Good night!', exampleTranslation: '晚安！',
    category: 'time', difficulty: 'easy', grade: '7', level: 'middle', image: '🌙'
  },
  {
    id: 'nine', word: 'nine', phoneticUS: '/naɪn/', phoneticUK: '/naɪn/',
    meaning: '九', example: 'Nine books.', exampleTranslation: '九本书。',
    category: 'numbers', difficulty: 'easy', grade: '7', level: 'middle', image: '9️⃣'
  },
  {
    id: 'nineteen', word: 'nineteen', phoneticUS: '/naɪnˈtiːn/', phoneticUK: '/naɪnˈtiːn/',
    meaning: '十九', example: 'I am nineteen.', exampleTranslation: '我19岁。',
    category: 'numbers', difficulty: 'easy', grade: '7', level: 'middle', image: '1️⃣9️⃣'
  },
  {
    id: 'ninety', word: 'ninety', phoneticUS: '/ˈnaɪnti/', phoneticUK: '/ˈnaɪnti/',
    meaning: '九十', example: 'Ninety percent.', exampleTranslation: '百分之九十。',
    category: 'numbers', difficulty: 'easy', grade: '8', level: 'middle', image: '9️⃣0️⃣'
  },
  {
    id: 'no', word: 'no', phoneticUS: '/noʊ/', phoneticUK: '/nəʊ/',
    meaning: '不', example: 'No problem.', exampleTranslation: '没问题。',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '❌'
  },
  {
    id: 'nobody', word: 'nobody', phoneticUS: '/ˈnoʊbɑdi/', phoneticUK: '/ˈnəʊbɒdi/',
    meaning: '没有人', example: 'Nobody knows.', exampleTranslation: '没人知道。',
    category: 'abstract', difficulty: 'easy', grade: '8', level: 'middle', image: '👤'
  },
  {
    id: 'noise', word: 'noise', phoneticUS: '/nɔɪz/', phoneticUK: '/nɔɪz/',
    meaning: '噪音', example: 'Too much noise.', exampleTranslation: '噪音太大。',
    category: 'abstract', difficulty: 'medium', grade: '8', level: 'middle', image: '🔊'
  },
  {
    id: 'noon', word: 'noon', phoneticUS: '/nuːn/', phoneticUK: '/nuːn/',
    meaning: '中午', example: 'At noon.', exampleTranslation: '在中午。',
    category: 'time', difficulty: 'easy', grade: '7', level: 'middle', image: '☀️'
  },
  {
    id: 'nor', word: 'nor', phoneticUS: '/nɔr/', phoneticUK: '/nɔ/',
    meaning: '也不', example: 'Neither you nor I.', exampleTranslation: '你和我都不。',
    category: 'abstract', difficulty: 'medium', grade: '9', level: 'middle', image: '❌'
  },
  {
    id: 'north', word: 'north', phoneticUS: '/nɔrθ/', phoneticUK: '/nɔθ/',
    meaning: '北方', example: 'North China.', exampleTranslation: '华北。',
    category: 'directions', difficulty: 'easy', grade: '7', level: 'middle', image: '🧭'
  },
  {
    id: 'nose', word: 'nose', phoneticUS: '/noʊz/', phoneticUK: '/nəʊz/',
    meaning: '鼻子', example: 'My nose.', exampleTranslation: '我的鼻子。',
    category: 'body', difficulty: 'easy', grade: '7', level: 'middle', image: '👃'
  },
  {
    id: 'not', word: 'not', phoneticUS: '/nɑt/', phoneticUK: '/nɒt/',
    meaning: '不', example: 'Not now.', exampleTranslation: '现在不。',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '❌'
  },
  {
    id: 'note', word: 'note', phoneticUS: '/noʊt/', phoneticUK: '/nəʊt/',
    meaning: '笔记；注意', example: 'Take notes.', exampleTranslation: '做笔记。',
    category: 'school', difficulty: 'easy', grade: '8', level: 'middle', image: '📝'
  },
  {
    id: 'notebook', word: 'notebook', phoneticUS: '/ˈnoʊtbʊk/', phoneticUK: '/ˈnəʊtbʊk/',
    meaning: '笔记本', example: 'Use a notebook.', exampleTranslation: '用笔记本。',
    category: 'school', difficulty: 'easy', grade: '7', level: 'middle', image: '📓'
  },
  {
    id: 'nothing', word: 'nothing', phoneticUS: '/ˈnʌθɪŋ/', phoneticUK: '/ˈnʌθɪŋ/',
    meaning: '没有东西', example: 'Nothing left.', exampleTranslation: '什么都不剩。',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '❌'
  },
  {
    id: 'notice', word: 'notice', phoneticUS: '/ˈnoʊtɪs/', phoneticUK: '/ˈnəʊtɪs/',
    meaning: '注意；通知', example: 'Notice the sign.', exampleTranslation: '注意标志。',
    category: 'abstract', difficulty: 'medium', grade: '9', level: 'middle', image: '⚠️'
  },
  {
    id: 'novel', word: 'novel', phoneticUS: '/ˈnɑvl/', phoneticUK: '/ˈnɒvl/',
    meaning: '小说', example: 'Read a novel.', exampleTranslation: '读小说。',
    category: 'hobbies', difficulty: 'medium', grade: '9', level: 'middle', image: '📖'
  },
  {
    id: 'November', word: 'November', phoneticUS: '/noʊˈvembər/', phoneticUK: '/nəʊˈvembə/',
    meaning: '十一月', example: 'November is cold.', exampleTranslation: '十一月很冷。',
    category: 'months', difficulty: 'easy', grade: '7', level: 'middle', image: '🍂'
  },
  {
    id: 'now', word: 'now', phoneticUS: '/naʊ/', phoneticUK: '/naʊ/',
    meaning: '现在', example: 'Do it now.', exampleTranslation: '现在做。',
    category: 'time', difficulty: 'easy', grade: '7', level: 'middle', image: '⏰'
  },
  {
    id: 'number', word: 'number', phoneticUS: '/ˈnʌmbər/', phoneticUK: '/ˈnʌmbə/',
    meaning: '数字', example: 'Phone number.', exampleTranslation: '电话号码。',
    category: 'numbers', difficulty: 'easy', grade: '7', level: 'middle', image: '🔢'
  },
  {
    id: 'nurse', word: 'nurse', phoneticUS: '/nɜrs/', phoneticUK: '/nɜs/',
    meaning: '护士', example: 'A kind nurse.', exampleTranslation: '善良的护士。',
    category: 'jobs', difficulty: 'easy', grade: '8', level: 'middle', image: '👩‍⚕️'
  },
];

export default vocabularyLN;